(function () {
  if (window.__iwtParallaxInit) return;
  window.__iwtParallaxInit = true;

  var GROUP_CLASS = 'iwt-parallax-group';
  var CARD_CLASS = 'iwt-parallax-card';

  function sectionOf(el) {
    return el.closest('.shopify-section') || el;
  }

  // Unwrap any groups we created previously so the DOM is flat before we rebuild.
  function teardown() {
    var groups = document.querySelectorAll('.' + GROUP_CLASS);
    groups.forEach(function (group) {
      var parent = group.parentNode;
      if (!parent) return;
      while (group.firstChild) {
        var child = group.firstChild;
        if (child.classList) {
          child.classList.remove(CARD_CLASS);
          child.style.zIndex = '';
        }
        parent.insertBefore(child, group);
      }
      parent.removeChild(group);
    });
  }

  function build() {
    teardown();

    var markers = Array.prototype.slice.call(
      document.querySelectorAll('[data-iwt-parallax]')
    );
    if (!markers.length) return;

    // Map markers to their unique .shopify-section wrappers, in document order.
    var sections = [];
    markers.forEach(function (marker) {
      var section = sectionOf(marker);
      if (section && sections.indexOf(section) === -1) {
        sections.push(section);
      }
    });

    // Walk the list, collecting runs of sections that are immediate siblings,
    // and wrap each run of 2+ into a stacking group.
    var i = 0;
    while (i < sections.length) {
      var run = [sections[i]];
      var j = i + 1;
      while (
        j < sections.length &&
        run[run.length - 1].nextElementSibling === sections[j]
      ) {
        run.push(sections[j]);
        j++;
      }

      if (run.length >= 2) {
        var group = document.createElement('div');
        group.className = GROUP_CLASS;
        run[0].parentNode.insertBefore(group, run[0]);
        run.forEach(function (section, index) {
          group.appendChild(section);
          section.classList.add(CARD_CLASS);
          // Later cards paint above earlier ones as they scroll up over them.
          section.style.zIndex = String(index + 1);
        });
      }

      i = j;
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      build();
    });
  }

  function ready() {
    build();
    // Rebuild when sections are added/removed/reordered in the theme editor.
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
